import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 220px 150px 48px;
  gap: 8px;
  align-items: center;
  padding: 12px 8px;
  border-bottom: 1px solid #e5e7eb;
  min-height: 60px;

  @media (max-width: 768px) {
    min-width: 450px;
  }
`;

const SkeletonBox = styled.div<{ width?: string; height?: string }>`
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "20px"};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`;

interface FeeRowSkeletonProps {
  count?: number;
}

export const FeeRowSkeleton = ({ count = 5 }: FeeRowSkeletonProps) => {
  // Generate stable keys for skeleton rows
  const skeletonKeys = Array.from(
    { length: count },
    (_, i) => `skeleton-${i}-${Math.random().toString(36).substr(2, 9)}`
  );

  return (
    <>
      {skeletonKeys.map(key => (
        <SkeletonRow key={key}>
          {/* Name */}
          <SkeletonBox height="16px" width="60%" />

          {/* Condition */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <SkeletonBox height="16px" width="80px" />
          </div>

          {/* Amount */}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <SkeletonBox height="16px" width="80px" />
          </div>

          {/* Action button */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <SkeletonBox height="28px" width="60px" />
          </div>
        </SkeletonRow>
      ))}
    </>
  );
};
